module.exports = __webpack_public_path__ + "static/media/buzz_crew_gfx.0890ce80.png";